import { useMemo } from 'react';

export const useComputedStates = (video, translation, historySync, isMobile) => {
  // 자막 로딩 상태 계산
  const transcriptLoading = useMemo(() => {
    return video.isStreaming && (!translation.currentTranscript || translation.currentTranscript.length === 0);
  }, [video.isStreaming, translation.currentTranscript]);

  // 헤더 높이 계산
  const headerHeight = useMemo(() => {
    return isMobile ? 40 : 56;
  }, [isMobile]);

  // 사이드바 너비 상수
  const sidebarWidth = 280;

  // 페이지 로딩 상태 계산
  const isPageLoading = useMemo(() => {
    return video.loading && !historySync.selectedHistory;
  }, [video.loading, historySync.selectedHistory]);

  // 스트리밍 활성 상태 계산
  const isActiveStreaming = useMemo(() => {
    return video.isStreaming && historySync.selectedHistory;
  }, [video.isStreaming, historySync.selectedHistory]);

  return {
    transcriptLoading,
    headerHeight,
    sidebarWidth,
    isPageLoading,
    isActiveStreaming
  };
}; 